<template>
  <div class="unsuccessful">
    <item-control-fulfillment-status
      :fulfillment-status="unsuccessfulStatus"
      class="mb-4"
    />
    <div v-if="!isPaymentRewardType">
      <p>
        {{ $t('redemption-history-unsuccessful.paragraph-1') }}
      </p>
      <i18n
        path="redemption-history-unsuccessful.paragraph-2"
        tag="p"
      >
        <router-link :to="{ name: catalogRoute }">
          {{
            $t('redemption-history-unsuccessful.link-text')
          }}
        </router-link>.
      </i18n>
    </div>
  </div>
</template>
<script>
import ItemControlFulfillmentStatus from '@/components/cart/ItemControlFulfillmentStatus'
import { FulfillmentStatus } from '@/cowboy/EnumTypes'
import { CATALOG_ROUTE } from '@/router/routes/route-names'
import { RedeemedItem } from '@/store/classes/redeemed-item'

export default {
  name: 'ItemUnsuccessful',
  components: {
    ItemControlFulfillmentStatus
  },
  props: {
    item: {
      type: RedeemedItem,
      required: true
    },
    isPaymentRewardType: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    unsuccessfulStatus () {
      return FulfillmentStatus.FAILED
    },
    catalogRoute () {
      return CATALOG_ROUTE
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/scss/variables';
.unsuccessful {
  .fullfillment-status-label {
    max-width: 130px;
    margin-bottom: map-get($spacers, 4);
  }
  p {
    line-height: 1.2rem;
    margin-bottom: 0.5rem;
    font-weight: bold;
  }
}
</style>
